import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { homeAnchor } from '../pages/HomePage';
import './Navbar.css';

const LINKS = [
  { href: homeAnchor('services'), label: 'Services' },
  { href: homeAnchor('apps'), label: 'Our Apps' },
  { href: homeAnchor('why'), label: "What's New" },
  { href: homeAnchor('vision'), label: 'Vision' },
  { href: homeAnchor('team'), label: 'Team' },
  { href: homeAnchor('invest'), label: 'Invest' },
  { href: homeAnchor('policies'), label: 'Policies' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="container navbar__inner">
        <Link to="/" className="navbar__brand">
          <img src="/assets/logo.jpg" alt="BikesDrop logo" className="navbar__logo" />
          <span>
            Bikes<span className="navbar__brand-accent">Drop</span>
          </span>
        </Link>

        <nav className={`navbar__links ${open ? 'navbar__links--open' : ''}`}>
          {LINKS.map((link) => (
            <Link key={link.href} to={link.href} onClick={() => setOpen(false)}>
              {link.label}
            </Link>
          ))}
          <Link className="navbar__faq-link" to="/faq/customer/" onClick={() => setOpen(false)}>
            FAQ
          </Link>
          <Link className="navbar__faq-link" to="/support/" onClick={() => setOpen(false)}>
            Support
          </Link>
          <Link className="btn btn--teal btn--sm navbar__cta" to={homeAnchor('download')} onClick={() => setOpen(false)}>
            Get the App
          </Link>
        </nav>

        <button
          className={`navbar__toggle ${open ? 'navbar__toggle--open' : ''}`}
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle navigation"
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
}
